module.exports = __webpack_public_path__ + "img/6A.54776e98.png";